import styled from 'styled-components';
import { rem } from 'polished';
import { ModalLogoutStyled } from '../ModalLogoutStyled';

export const ModalLogoutStyledDS = styled(ModalLogoutStyled)`
    
`;
